import Address from './Address';

export default class MortgageeRequest {
	public name: string | null = null;
	public includeSuccessorOrAssigns: boolean | null = null;
	public includeInterests: boolean | null = null;
	public loanNumber: string | null = null;
	public positionNumber: number | null = null;
	public isMortgageeBilled: boolean | null = null;
	public isMortgageeRequired: boolean | null = null;
	public address: Address | null = null;
	public email: string | null = null;
	public sendPaymentReceiptToMortgagee: boolean | null = null;

	public constructor() {

	}
}
